<div class="plancrtprt" *ngIf="!isCoverageInfo">
  <div class="main_plan">
    <div class="panel_heading">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header>
            <div class="plan_term">
              <ng-container *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                Monthly
              </ng-container>
              <ng-container *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                Yearly
              </ng-container>
              <ng-container
                *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
              >
              {{checkoutService.getSignaturePlanText(planForm)}}
              </ng-container>
            </div>
            <mat-panel-title>
              <h3 class="panel-title main-title">
                {{ selectedPlanPrice?.plan_optional_item_category?.title | uppercase }}
              </h3>
              <b>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY MONTHLY'"
                >
                  {{ selectedPlanPrice?.discountedMonthlyPrice | currency }}
                </ng-container>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY ANNUALLY'"
                >
                  {{ selectedPlanPrice?.discountedYearlyPrice | currency }}
                </ng-container>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
                >
                ${{checkoutService.getSignaturediscountedPrice(selectedPlanPrice, planForm) | currency:'':''}}
                </ng-container>
              </b>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="inner_cont">
            <span>
              <b>Property type:</b>
              {{ selectedPlanPrice?.plan_property_type?.title }}
            </span>
            <span>
              <b>Property size:</b>
              {{ selectedPlanPrice?.plan_property_size?.title }}
            </span>
          </div>
          <div class="inner_cont">
            <span> <b> Copay fee: </b> {{ coPayFee | currency }} </span>
          </div>
          <div class="inner_cont" *ngIf="fieldConfiguration?.stepNumber === 3">
            <span *ngIf="paymentMethod !== PaymentMethods.escrow"> <b> Waiting Period </b> 
              <form [formGroup]="waitingPeriodForm" class="position-relative">
                <div class="input_wrap">
                  <input type="text" formControlName="waitingPeriod"  mask="0||00||000"> 
                  <div class="prefixprt">
                      Days
                  </div>
                </div>
                
             
                <mat-error *ngIf="waitingPeriodForm.controls['waitingPeriod'].touched && waitingPeriodForm.controls['waitingPeriod'].hasError('required')">
                   This is required.
                </mat-error>
                <mat-error *ngIf="waitingPeriodForm.controls['waitingPeriod'].touched && waitingPeriodForm.controls['waitingPeriod'].hasError('min')">
                    Minimum value should be 0.
                 </mat-error>
              </form>
             </span>
             <span *ngIf="paymentMethod === PaymentMethods.escrow">
              <b> Waiting Period </b>
              <div class="input_wrap">
                <input type="text" value="0" [attr.disabled]="true">
                <div class="prefixprt">
                  Days
                </div>
              </div>
             
             </span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="optionalprt" *ngIf="selectedOptionalCoverItems.length > 0">
    <div class="panel_heading">
      <mat-accordion>
        <mat-expansion-panel [expanded]="optionalPanelOpenState">
          <mat-expansion-panel-header>
            <div class="plan_term">
              <ng-container *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                Monthly
              </ng-container>
              <ng-container *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                Yearly
              </ng-container>
              <ng-container
                *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
              >
              {{checkoutService.getSignaturePlanText(planForm)}}
              </ng-container>
            </div>
            <mat-panel-title>
              <h3 class="panel-title main-title">OPTIONAL ITEMS</h3>
              <b>
                {{ selectedOptionalItemsPlanWise | currency }}
              </b>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="item_list">
            <ul>
              <li *ngFor="let item of selectedOptionalCoverItems">
                <span>
                  <h3>{{ item.title | titlecase }}</h3>
                </span>
                <div class="item_right">
                  <b>
                    {{
                      calculateOptionalItemValue(item.standardPrice, true, true)
                        | currency
                    }} x {{ item?.quantity }}
                  </b>
                  <span
                    *ngIf="fieldConfiguration.stepNumber === 3 && !loading"
                    (click)="handleDeleteOptionalItems(item)"
                  >
                    <mat-icon>close</mat-icon>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="totalcostarea">
    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber !== 2}">
      Total cost

      <span>{{ totalCostPrice | currency }}</span>
    </span>

    <span *ngIf="salesTax > 0" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber !== 2}">
      Tax
      <span>{{ salesTax | currency }}</span>
    </span>
    
    <span *ngIf="additionalDiscount > 0" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber !== 2}">
      Additional Discount
      <span>{{ additionalDiscount | currency }}</span>
    </span>
    
    <span  *ngIf="processingFee > 0" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber !== 2}">
      Processing
       <span>{{ processingFee | currency }}</span>
    </span>

    <span [ngClass]="{ sub_totalprt: isFromBilling, 'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber !== 2 }" >
      <b>Sub total</b>

      <b> {{ subTotalWithDiscounts | currency }}</b>
    </span>
    <span *ngIf="fieldConfiguration?.stepNumber === 3 && isSuperAdmin">
      <form [formGroup]="customPriceForm" style="width: 100%;">
        <div class="blue_panel">
          <mat-checkbox formControlName="isCustomPrice" (change)="handleIsCustomPriceChange($event)" class="check_field"><b>Complete Custom Price Override</b></mat-checkbox>
          <div class="custom_field" *ngIf="customPriceForm.controls['isCustomPrice'].value">
            <label>Enter Custom Total Price</label>
            <input type="text" formControlName="customPrice" mask="separator.2" thousandSeparator=","  prefix="$" placeholder="Custom Price" (change)="handleCustomPriceChange()">
            <mat-error *ngIf="customPriceForm.controls['customPrice'].touched && customPriceForm.controls['customPrice'].hasError('min')">
              Minimum value should be 1.
            </mat-error>
             <mat-error *ngIf="customPriceForm.controls['customPrice'].touched && customPriceForm.controls['customPrice'].hasError('required')">
              Please enter override price.
            </mat-error>
          </div>
        </div>
      </form>
    </span>
    <span class="red" *ngIf="fieldConfiguration.youSaved" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value  && fieldConfiguration?.stepNumber !== 2}">
      <span>
        {{
          planForm.value?.planType === "PAY MONTHLY"
            ? "Total yearly savings"
            : "Total savings"
        }}
      </span>

      <b> {{ totalSavings | currency }}</b>
    </span>
    <span *ngIf="isSuperAdmin && customPriceForm.get('isCustomPrice')?.value && fieldConfiguration?.stepNumber === 4">
      Total being charged (overridden)
      <span>
        {{customPriceForm.get('customPrice')?.value}}
      </span>
    </span>

    
    <span
      *ngIf="
        planForm.value?.planType === 'PAY MONTHLY' &&
        fieldConfiguration.monthlyPayment
      "
    >
      <!-- <p>
        Monthly payment
        <small style="display: block; color: #a6a6a6">
       <form [formGroup]="planForm">
        <mat-select formControlName="monthlyPaymentDate">
          <mat-option *ngFor="let item of daysOption" [value]="item">{{item}}</mat-option>
        </mat-select>
       </form>
       of each month
        </small>
      </p> -->

      <p>
        <span class="flex">
          Monthly payment
        </span>
        
        <small style="display: flex; color: #a6a6a6; align-items: center;">
          <form [formGroup]="planForm">
            <div class="select_panel">
              <mat-select formControlName="monthlyPaymentDate">
                <mat-option *ngFor="let item of daysOption" [value]="item">{{item}}</mat-option>
              </mat-select>
            </div>
            
          </form>
          of each month
        </small>
      </p>

      <b> {{ subTotalWithDiscounts | currency }}</b>
    </span>
    <span *ngIf="fieldConfiguration.effectiveTerm">
      <p>Effective Term</p>

      <span *ngIf="!isCoverageInfo">
        {{ effectiveTermDate }}
      </span>
      <span *ngIf="isCoverageInfo">
        {{updateCoverageDetails?.effectiveTerm }}
      </span>
    </span>
    <span *ngIf="fieldConfiguration.totalCharged">
      <ng-container *ngIf="paymentMethod !== PaymentMethods.escrow && !showEscrowCard">
        <div class="changecont">
          <b [ngClass]="{'red': subTotalWithDiscounts <0}"  > Total being charged today </b>
          <b>{{customPriceForm.get('isCustomPrice')?.value ? ((customPriceForm.get('customPrice')?.value || 0) | currency) : (subTotalWithDiscounts | currency) }}</b>
        </div>
      </ng-container>

      <ng-container *ngIf="paymentMethod === PaymentMethods.escrow && !showEscrowCard">
        <div class="changecont">
          <b [ngClass]="{'red': subTotalWithDiscounts <0}" > Total due at closing date </b>
          <b>{{customPriceForm.get('isCustomPrice')?.value ? ((customPriceForm.get('customPrice')?.value || 0) | currency) : (subTotalWithDiscounts | currency) }}</b>
        </div>
      </ng-container>

      <ng-container *ngIf="paymentMethod === PaymentMethods.escrow && showEscrowCard">
        <div class="changecont">
          <b  [ngClass]="{'red': escrowTotalCharged <0}" > Total due at closing date </b>
          <b>{{ escrowTotalCharged | currency }}</b>
        </div>
        
        <ng-container *ngIf="escrowDetailsForm.get('closingAmount')?.value > 0">
          <div class="changecont">
            <b  [ngClass]="{'red': escrowDetailsForm.get('closingAmount')?.value < 0}" > Total being charged today </b>
            <b>{{ escrowDetailsForm.get("closingAmount")?.value | currency }}</b>
          </div>
          
        </ng-container>
      </ng-container>
      <div class="full-width" *ngIf="showInstalmentPart && planForm.value?.planType !== 'PAY MONTHLY'">
        <div class="toggle_btn">
          <span (click)="toggleInstallmentPayment(true)" [ngClass]="{'active': isOnetimePayment}">One Time Payment</span>
          <span (click)="toggleInstallmentPayment(false)" [ngClass]="{'active': !isOnetimePayment}">Payment Plan</span>
        </div>
        <ng-container *ngIf="!isOnetimePayment">
          <form [formGroup]="installmentForm">
            <div class="signature_prt" >
            
              <mat-radio-group formControlName="installmentType">
                <mat-radio-button *ngFor="let item of repeatArray(installmentLimits); index as i"  [value]="i + 1">{{installmentText(i+1)}}</mat-radio-button>
              </mat-radio-group>
            </div>
            </form>
            <div>
              <div class="info_heading rightinfo_heading">

                <div class="info_input" *ngIf="this.installmentForm.get('installmentType').value !== 1">
                  <label>Initial Payment</label>
                  <div class="info_input">
                    <input type="text" mask="separator.2" thousandSeparator=","  prefix="$" [(ngModel)]="initialIntallmentPaymentPrice" [max]="showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value || 0 : subTotalWithDiscounts" [attr.disabled]="disabledInitialPaymentField ? true : null">
    
                    <button *ngIf="disabledInitialPaymentField" (click)="handleInitialPaymentChange()">
                        <mat-icon >edit</mat-icon>
                    </button>
                    <button *ngIf="!disabledInitialPaymentField" (click)="handleInitialPaymentChange()" >
                        <mat-icon >check</mat-icon>
                        
                    </button>
                  </div>
                   
                </div>
                <!-- False Initial Payment for One Time Payment -->
                <div class="info_input" *ngIf="this.installmentForm.get('installmentType').value === 1">
                  <label>{{onTimeInitialPayment}}</label>
                  <div class="info_input">
                    <input type="text" mask="separator.2" thousandSeparator=","  prefix="$" [(ngModel)]="firstInstallmentPrice" [attr.disabled]="true">
                  </div>
                   
                </div>
               

                <mat-error
                *ngIf="!customPriceForm.get('isCustomPrice').value && (initialIntallmentPaymentPrice > (showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value : subTotalWithDiscounts))">
                Enter a amount less than or equals to ${{showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value : subTotalWithDiscounts}}.
                </mat-error>
                <!-- error for custom price -->
                <mat-error
                *ngIf="customPriceForm.get('isCustomPrice').value && (initialIntallmentPaymentPrice > customPriceForm.get('customPrice').value || 0)">
                Enter a amount less than or equals to ${{customPriceForm.get('customPrice').value || 0}}.
                </mat-error>
              </div>
            </div>
            <form [formGroup]="installmentForm">
              <div class="data_calender">
                <div class="datapick">
                  <label>Initial Payment Date</label>
                  <mat-form-field class="example-full-width" appearance="outline">
                      <input matInput formControlName="initialPaymentData" [matDatepicker]="picker" (click)="picker.open()" [readonly]="true" [max]="maxDate()" [min]="minData">
                      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-error
                  *ngIf="installmentForm.controls['initialPaymentData'].touched && installmentForm.controls['initialPaymentData'].hasError('required')">
                  This is required.
                  </mat-error>
                </div>
              
                <div class="datapick" *ngIf="showInstallmentdate && showInstallmentPaymentDate">
                    <label>Installment Payment Date</label>
                    <mat-form-field class="example-full-width" appearance="outline">
                        <input matInput formControlName="installmentData" [matDatepicker]="picker1" (click)="picker1.open()" [readonly]="true" [max]="maxDate()" [min]="installmentMinDate" (dateChange)="datePickerhandleChange($event)">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                    *ngIf="installmentForm.controls['installmentData'].touched && installmentForm.controls['installmentData'].hasError('required')">
                    This is required.
                    </mat-error>
                </div>
              </div>
          </form>
          <ul class="listprt" *ngIf="showInstallmentdate">
            <li *ngFor="let item of dates; let last = last">
              {{item}} 
              <b>
                {{last ? (installmentPayment?.lastInstallment | currency) : (installmentPayment?.amoundividedByMonth| currency)}}
                <!-- {{installmentPayment?.amoundividedByMonth | currency}} -->
              </b>
            </li>
          </ul>

        </ng-container>
      </div>
      
    </span>
  </div>
</div>
<div class="plancrtprt" *ngIf="isCoverageInfo">
  <div class="main_plan">
    <div class="panel_heading">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header>
            <div class="plan_term">
              <ng-container *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                Monthly
              </ng-container>
              <ng-container *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                Yearly
              </ng-container>
              <ng-container
                *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
              >
              {{checkoutService.getSignaturePlanText(planForm)}}
              </ng-container>
            </div>
            <mat-panel-title>
              <h3 class="panel-title main-title">
                {{ selectedPlanPrice?.plan_optional_item_category?.title | uppercase }}
              </h3>
              <b>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY MONTHLY'"
                >
                  {{ selectedPlanPrice?.discountedMonthlyPrice | currency }}
                </ng-container>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY ANNUALLY'"
                >
                  {{ selectedPlanPrice?.discountedYearlyPrice | currency }}
                </ng-container>
                <ng-container
                  *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
                >
                ${{checkoutService.getSignaturediscountedPrice(selectedPlanPrice, planForm) | currency:'':''}}
                </ng-container>
              </b>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="inner_cont">
            <span>
              <b>Property type:</b>
              {{ selectedPlanPrice?.plan_property_type?.title }}
            </span>
            <span>
              <b>Property size:</b>
              {{ selectedPlanPrice?.plan_property_size?.title }}
            </span>
          </div>
          <div class="inner_cont" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
            <span> <b> Copay fee: </b> {{ coPayFee | currency }} </span>
          </div>
      
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="optionalprt" *ngIf="selectedOptionalCoverItems.length > 0">
    <div class="panel_heading">
      <mat-accordion>
        <mat-expansion-panel [expanded]="optionalPanelOpenState">
          <mat-expansion-panel-header>
            <div class="plan_term">
              <ng-container *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                Monthly
              </ng-container>
              <ng-container *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                Yearly
              </ng-container>
              <ng-container
                *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"
              >
              {{checkoutService.getSignaturePlanText(planForm)}}
              </ng-container>
            </div>
            <mat-panel-title>
              <h3 class="panel-title main-title">OPTIONAL ITEMS</h3>
              <b>
                {{ selectedOptionalItemsPlanWise | currency }}
              </b>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="item_list">
            <ul>
              <li *ngFor="let item of selectedOptionalCoverItems">
                <span>
                  <h3>{{ item.title | titlecase }}</h3>
                </span>
                <div class="item_right">
                  <b>
                    {{
                      calculateOptionalItemValue(item.standardPrice, true, true)
                        | currency
                    }} x {{ item?.quantity }}
                  </b>
                  <span
                    *ngIf="fieldConfiguration.stepNumber === 3 && !loading"
                    (click)="handleDeleteOptionalItems(item)"
                  >
                    <mat-icon>close</mat-icon>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="totalcostarea">
    <span>
      Effective Term

      <span>{{ updateCoverageDetails?.effectiveTerm }}</span>
    </span>

    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Agreement Price

      <span>{{ updateCoverageDetails?.agreementPrice | currency }}</span>
    </span>
    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Additional Price

      <span>{{  updateCoverageDetails?.additionalPrice | currency }}</span>
    </span>
    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Reflected Copay Amount
      <span>{{ updateCoverageDetails?.reflectedCopayAmount | currency }}</span>
    </span>
    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
            Processing
      <span>{{ updateCoverageDetails?.processingFee | currency }}</span>
    </span>

    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Total Amount
      <span>{{ updateCoverageDetails?.totalAmount | currency }}</span>
    </span>

    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Discounted Price
      <span>{{ updateCoverageDetails?.discountedPrice | currency }}</span>
    </span>

    <span [ngClass]="{ sub_totalprt: isFromBilling, 'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3 }">
      <b>Sub total</b>

      <b> {{ updateCoverageDetails?.subTotalAmount | currency }}</b>
    </span>
    <span *ngIf="fieldConfiguration?.stepNumber === 3 && isSuperAdmin">
      <form [formGroup]="customPriceForm" style="width: 100%;">
        <div class="blue_panel">
          <mat-checkbox formControlName="isCustomPrice" (change)="handleIsCustomPriceChange($event)" class="check_field"><b>Complete Custom Price Override</b></mat-checkbox>
          <div class="custom_field" *ngIf="customPriceForm.controls['isCustomPrice'].value">
            <label>Enter Custom Total Price</label>
            <input type="text" formControlName="customPrice" mask="separator.2" thousandSeparator=","  prefix="$" placeholder="Custom Price" (change)="handleCustomPriceChange()">
            <mat-error *ngIf="customPriceForm.controls['customPrice'].touched && customPriceForm.controls['customPrice'].hasError('min')">
              Minimum value should be 1.
            </mat-error>
             <mat-error *ngIf="customPriceForm.controls['customPrice'].touched && customPriceForm.controls['customPrice'].hasError('required')">
              Please enter override price.
            </mat-error>
          </div>
        </div>
      </form>
    </span>
    <span [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      Premium Paid
      <span>{{ updateCoverageDetails?.premiumPaid | currency }}</span>
    </span>

    <span  *ngIf="updateCoverageDetails?.extraCharge>0" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      <b class="red" >Extra Charge </b>
      <span> <b class="red" >{{ updateCoverageDetails?.extraCharge | currency }} </b></span>
    </span>

    <span  *ngIf="updateCoverageDetails?.refundAmount>0" [ngClass]="{'price_override': customPriceForm.controls['isCustomPrice'].value && fieldConfiguration?.stepNumber === 3}">
      <b class="red" >Refund Amount</b>
      <span><b class="red" > {{ updateCoverageDetails?.refundAmount | currency }}  </b></span>
    </span>


      <span  *ngIf="updateCoverageDetails?.refundAmount === 0 && updateCoverageDetails?.extraCharge === 0 &&  fieldConfiguration?.stepNumber === 3">
      <b class="red" >No Additional Amount has been charged.</b>
    
    </span>

    <span  *ngIf="updateCoverageDetails?.refundAmount === 0 && updateCoverageDetails?.extraCharge === 0 &&  fieldConfiguration?.stepNumber !== 3">
      <b class="red" >No Additional Amount will be charged.</b>
    
    </span>
    
    <span
      *ngIf="
        planForm.value?.planType === 'PAY MONTHLY' &&
        fieldConfiguration.monthlyPayment
      "
    >
    <p>
      <span class="flex">
        Monthly payment
      </span>
      
      <small style="display: flex; color: #a6a6a6; align-items: center;">
        <form [formGroup]="planForm">
          <div class="select_panel">
            <mat-select formControlName="monthlyPaymentDate">
              <mat-option *ngFor="let item of daysOption" [value]="item">{{item}}</mat-option>
            </mat-select>
          </div>
          
        </form>
        of each month
      </small>
    </p>

      <b> {{ subTotalWithDiscounts | currency }}</b>
    </span>

    <span *ngIf="fieldConfiguration.totalCharged">
      <ng-container *ngIf="paymentMethod !== PaymentMethods.escrow && !showEscrowCard && updateCoverageDetails?.extraCharge>0 && !customPriceForm.get('isCustomPrice')?.value">
        <div class="changecont">
          <b [ngClass]="{'red': updateCoverageDetails?.extraCharge>0}"  > Total Being Charged Today </b>
          <b>{{ updateCoverageDetails?.extraCharge | currency }}</b>
        </div>
      </ng-container>
      <ng-container *ngIf="customPriceForm.get('isCustomPrice')?.value">
        <div class="changecont">
          <b [ngClass]="{'red': updateCoverageDetails?.extraCharge>0}"  > Total Being Charged Today </b>
          <b>{{ customPriceForm.get('customPrice')?.value | currency }}</b>
        </div>
      </ng-container>

  

      <div class="full-width" *ngIf="showInstalmentPart && planForm.value?.planType !== 'PAY MONTHLY' && updateCoverageDetails?.extraCharge>0">
        <div class="toggle_btn">
          <span (click)="toggleInstallmentPayment(true)" [ngClass]="{'active': isOnetimePayment}">One Time Payment</span>
          <span (click)="toggleInstallmentPayment(false)" [ngClass]="{'active': !isOnetimePayment}">Payment Plan</span>
        </div>
        <ng-container *ngIf="!isOnetimePayment">
          <form [formGroup]="installmentForm">
            <div class="signature_prt" >
            
              <mat-radio-group formControlName="installmentType">
                <mat-radio-button *ngFor="let item of repeatArray(installmentLimits); index as i"  [value]="i + 1">{{installmentText(i+1)}}</mat-radio-button>
              </mat-radio-group>
            </div>
            </form>
            <div>
              <div class="info_heading rightinfo_heading">

                <div class="info_input" *ngIf="this.installmentForm.get('installmentType').value !== 1">
                  <label>Initial Payment</label>
                  <div class="info_input">
                    <input type="text" mask="separator.2" thousandSeparator=","  prefix="$" [(ngModel)]="initialIntallmentPaymentPrice" [max]="showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value || 0 : subTotalWithDiscounts" [attr.disabled]="disabledInitialPaymentField ? true : null">
    
                    <button *ngIf="disabledInitialPaymentField" (click)="handleInitialPaymentChange()">
                        <mat-icon >edit</mat-icon>
                    </button>
                    <button *ngIf="!disabledInitialPaymentField" (click)="handleInitialPaymentChange()" >
                        <mat-icon >check</mat-icon>
                        
                    </button>
                  </div>
                   
                </div>
                <!-- False Initial Payment for One Time Payment -->
                <div class="info_input" *ngIf="this.installmentForm.get('installmentType').value === 1">
                  <label>{{onTimeInitialPayment}}</label>
                  <div class="info_input">
                    <input type="text" mask="separator.2" thousandSeparator=","  prefix="$" [(ngModel)]="firstInstallmentPrice" [attr.disabled]="true">
                  </div>
                   
                </div>
               

                 <mat-error
                *ngIf="!customPriceForm.get('isCustomPrice').value && (initialIntallmentPaymentPrice > (showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value : updateCoverageDetails?.extraCharge))">
                Enter a amount less than or equals to ${{showEscrowCard ? escrowDetailsForm.get('closingAmount')?.value : updateCoverageDetails?.extraCharge}}.
                </mat-error>
                <!-- error for custom price -->
                <mat-error
                *ngIf="customPriceForm.get('isCustomPrice').value && (initialIntallmentPaymentPrice > customPriceForm.get('customPrice').value || 0)">
                Enter a amount less than or equals to ${{customPriceForm.get('customPrice').value || 0}}.
                </mat-error>
              </div>
            </div>
            <form [formGroup]="installmentForm">
              <div class="data_calender">
                <div class="datapick">
                  <label>Initial Payment Date</label>
                  <mat-form-field class="example-full-width" appearance="outline">
                      <input matInput formControlName="initialPaymentData" [matDatepicker]="picker" (click)="picker.open()" [readonly]="true" [max]="maxDate()" [min]="minData">
                      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-error
                  *ngIf="installmentForm.controls['initialPaymentData'].touched && installmentForm.controls['initialPaymentData'].hasError('required')">
                  This is required.
                  </mat-error>
                </div>
              
                <div class="datapick" *ngIf="showInstallmentdate && showInstallmentPaymentDate">
                    <label>Installment Payment Date</label>
                    <mat-form-field class="example-full-width" appearance="outline">
                        <input matInput formControlName="installmentData" [matDatepicker]="picker1" (click)="picker1.open()" [readonly]="true" [max]="maxDate()" [min]="installmentMinDate" (dateChange)="datePickerhandleChange($event)">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                    *ngIf="installmentForm.controls['installmentData'].touched && installmentForm.controls['installmentData'].hasError('required')">
                    This is required.
                    </mat-error>
                </div>
              </div>
          </form>
          <ul class="listprt" *ngIf="showInstallmentdate">
            <li *ngFor="let item of dates; let last = last">
              {{item}} 
              <b>
                {{last ? (installmentPayment?.lastInstallment | currency) : (installmentPayment?.amoundividedByMonth| currency)}}
                <!-- {{installmentPayment?.amoundividedByMonth | currency}} -->
              </b>
            </li>
          </ul>

        </ng-container>
      </div>
      
    </span>
  </div>
</div>
